import { render, staticRenderFns } from "./ProfileGallery.vue?vue&type=template&id=51a31cfa&scoped=true"
import script from "./ProfileGallery.vue?vue&type=script&lang=js"
export * from "./ProfileGallery.vue?vue&type=script&lang=js"
import style0 from "./ProfileGallery.vue?vue&type=style&index=0&id=51a31cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a31cfa",
  null
  
)

export default component.exports